module.exports = __webpack_public_path__ + "static/media/drop-darkGrey.036614b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/drop-darkGrey.svg
// module id = 285
// module chunks = 0